/**
 * Login related constants
 */

// User types
export const USER_TYPE = {
  CORPORATE_MANAGER: "CORPORATE_MANAGER",
  MIDDLE_MANAGER: "MIDDLE_MANAGER",
} as const;

// Company types
export const COMPANY_TYPE = {
  SELLER: "SELLER",
  BUYER: "BUYER",
  BOTH: "BOTH",
} as const;

// Subscription statuses
export const SUBSCRIPTION_STATUS = {
  PROGRESS: "PROGRESS",
  CANCELED: "CANCELED",
  FINISHED: "FINISHED",
  NOT_PAID_YET: "NOT_PAID_YET",
  PAYMENT_FAIL: "PAYMENT_FAIL",
} as const;

// Subscription types
export const SUBSCRIPTION_TYPE = {
  FREE: "FREE",
  STANDARD: "STANDARD",
  PREMIUM: "PREMIUM",
  ENTERPRISE: "ENTERPRISE",
} as const;

// Plan names
export const PLAN_NAME = {
  FREE_TRIAL: "Free Trial",
} as const;

export type UserType = typeof USER_TYPE[keyof typeof USER_TYPE];
export type CompanyType = typeof COMPANY_TYPE[keyof typeof COMPANY_TYPE];
export type SubscriptionStatus = typeof SUBSCRIPTION_STATUS[keyof typeof SUBSCRIPTION_STATUS];
export type SubscriptionType = typeof SUBSCRIPTION_TYPE[keyof typeof SUBSCRIPTION_TYPE];
